import axios from 'axios';
import { apiUrl } from '@/api/config';
import { getAuthToken } from '@/utils/auth';

/**
 * Service to handle initial application data fetching in a single request.
 */
export const initAPI = {
    /**
     * Get the initial state for the application (Profile, Preferences, Points).
     * @param {string} portal - 'student' or 'teacher'
     * @returns {Promise<Object|null>} Initial state data or null if not authenticated
     */
    getInitialState: async (portal = 'student') => {
        try {
            const token = getAuthToken(portal);
            if (!token) return null;

            const response = await axios.get(apiUrl('users/init/'), {
                headers: { Authorization: `Bearer ${token}` }
            });
            return response.data;
        } catch (error) {
            console.error('[initAPI] Failed to fetch initial state:', error);
            // Handle 401 or token expiration if necessary
            return null;
        }
    }
};
